export default "__VITE_ASSET__DacpCbWC__"